<template>
  <v-card class="card-height-300">
    <p class="inverter-item">
      {{item.name}}:
      <strong>{{item.gen}} kWh</strong>
    </p>
  </v-card>
</template>

<script>
export default {
  props: ['item']
}
</script>

<style scoped>
.card-height-300 {
  max-height: 300px;
  overflow-y: auto;
  width: 16vw;
  background: var(--v-primary-base);
  text-align: center;
}

.inverter-item {
  padding: 10px 30px;
}

@media (max-width:960px) {
  .card-height-300 {
    width: 50vw;
  }
 }
</style>
